export default "<app-estimation-lines-list></app-estimation-lines-list>";